'use strict';

export default from 'babel-loader!./src/index.babel.js';



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-vue-layer/index.babel.js